import { Box, Collapsible, Tabs } from '@chakra-ui/react';
import ProbabilityChart from '@features/prediction-markets/ProbabilityChart';
import { MarketOutcome, PredictionMarket } from '@features/prediction-markets/types';
import { memo } from 'react';

interface Props {
  market: PredictionMarket;
  outcome: MarketOutcome;
}

const TABS = [
  { key: 'order-book', label: 'Order Book' },
  { key: 'graph', label: 'Graph' },
  { key: 'resolution', label: 'Resolution' },
];

const OutcomeRowExpanded = ({ market, outcome }: Props) => {
  return (
    <Collapsible.Content>
      <Box bg="surface.background" borderRadius="lg" mx={2} mb={2} overflow="hidden">
        <Tabs.Root defaultValue="graph" size="sm">
          <Tabs.List px={4} pt={2}>
            {TABS.map((tab) => (
              <Tabs.Trigger key={tab.key} value={tab.key}>
                {tab.label}
              </Tabs.Trigger>
            ))}
          </Tabs.List>
          <Tabs.Content value="order-book" px={4} py={3}>
            <Box color="text.secondary" fontSize="sm">
              Order book coming soon.
            </Box>
          </Tabs.Content>
          <Tabs.Content value="graph" p={0}>
            <ProbabilityChart market={market} outcome={outcome} />
          </Tabs.Content>
          <Tabs.Content value="resolution" px={4} py={3}>
            <Box color="text.secondary" fontSize="sm">
              Resolution details coming soon.
            </Box>
          </Tabs.Content>
        </Tabs.Root>
      </Box>
    </Collapsible.Content>
  );
};

export default memo(OutcomeRowExpanded);
